import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PluginFeature } from '../../types/Spreadsheet';
import { RootState } from '../store';

interface PluginFeaturesState {
  items: PluginFeature[];
}

const initialState: PluginFeaturesState = {
  items: []
};

const pluginFeaturesSlice = createSlice({
  name: 'pluginFeatures',
  initialState,
  reducers: {
    addPluginFeature( state, action: PayloadAction<PluginFeature> ) {
      state.items.push( action.payload );
    },
    setPluginFeatures( state, action: PayloadAction<PluginFeature[]> ) {
      state.items = action.payload;
    },
    clearPluginFeatures( state ) {
      state.items = [];
    }
  }
});

export const { addPluginFeature, setPluginFeatures, clearPluginFeatures } = pluginFeaturesSlice.actions;

export default pluginFeaturesSlice.reducer;

//Selector
export const selectAllPluginFeatures = ( state: RootState ) => state.spreadsheet.pluginFeatures.items;


